import React from 'react'
import { Navigate } from 'react-router-dom'
import { ROUTES } from '../modules/routing/config/constants'

const HomeRoute = () => (
  <Navigate to={ROUTES.LOGIN.RELATIVE_PATH} replace />
)

export default HomeRoute
